import Overview from './overview.vue';
import FullIndex from '@rebuild/materials/shared/us_announcement/FullIndex.vue';
import MobOverview from '@/rebuild/materials/shared/us_announcement/mobile/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/us_announcement/mobile/MobFull.vue';

export const componentMap = {
	overview: Overview,
	full: FullIndex,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 